module.exports = __webpack_public_path__ + "static/media/signature.cc76fbcc.png";